export const INVALID_TIME_IN_MIN = 1; // prod to 1, debug 0
export const WARNING_TIME_IN_MIN = 10;
